import { FcsFlag } from "../unleash";

export const FlagsMapsPickup = {
  permission_google_maps_pickup_search_enable: new FcsFlag.Flag(false)
};

export function initFlagsMapsPickup() {
  FcsFlag.register("featureWebsiteMapsPickup", FlagsMapsPickup);
}
